/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createGetFeatureFlagsResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, type ErrorResponse, type GetFeatureFlagsResponse, type InternalErrorResponse } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/feature-flags
 */
export interface FeatureFlagsRequestBuilder extends BaseRequestBuilder<FeatureFlagsRequestBuilder> {
    /**
     * Returns every boolean feature flag in force for the caller's organization, or for UseOrganizationId when a sales rep works in another of their organizations. These are the values the API's own checks use. A flag changed in the identity provider shows here within five minutes for an organization other than the token's own, and at the next sign-in for the token's own.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<GetFeatureFlagsResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<FeatureFlagsRequestBuilderGetQueryParameters> | undefined) : Promise<GetFeatureFlagsResponse | undefined>;
    /**
     * Returns every boolean feature flag in force for the caller's organization, or for UseOrganizationId when a sales rep works in another of their organizations. These are the values the API's own checks use. A flag changed in the identity provider shows here within five minutes for an organization other than the token's own, and at the next sign-in for the token's own.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<FeatureFlagsRequestBuilderGetQueryParameters> | undefined) : RequestInformation;
}
/**
 * Returns every boolean feature flag in force for the caller's organization, or for UseOrganizationId when a sales rep works in another of their organizations. These are the values the API's own checks use. A flag changed in the identity provider shows here within five minutes for an organization other than the token's own, and at the next sign-in for the token's own.
 */
export interface FeatureFlagsRequestBuilderGetQueryParameters {
    /**
     * Optional: the organization whose flags to return (must be in the user's OrgCodes).
     */
    useOrganizationId?: string;
}
/**
 * Uri template for the request builder.
 */
export const FeatureFlagsRequestBuilderUriTemplate = "{+baseurl}/api/feature-flags{?useOrganizationId*}";
/**
 * Metadata for all the requests in the request builder.
 */
export const FeatureFlagsRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: FeatureFlagsRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createGetFeatureFlagsResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
